import HeadingSectionComponent from './HeadingSectionComponent'
export default HeadingSectionComponent
export * from './HeadingSectionComponent'
